import { request } from "../../api/api";

export const getStatusCount = (start_datetime, end_datetime) => {
  return request.get(
    `/tunnel_oven/getBatchStatusCount/?start_datetime=${start_datetime}&end_datetime=${end_datetime}`
  );
};
export const getClassWiseBatchStatusCount = (start_datetime, end_datetime) => {
    return request.get(
      `/tunnel_oven/getClassWiseBatchStatusCount/?start_datetime=${start_datetime}&end_datetime=${end_datetime}`
    );
  };

  export const getClassWiseInProgressBatchCount = (start_datetime, end_datetime) => {
    return request.get(
      `/tunnel_oven/getClassWiseInProgressBatchCount/?start_datetime=${start_datetime}&end_datetime=${end_datetime}`
    );
  };
  export const getDayWiseBatchStatusCount = (start_datetime, end_datetime) => {
    return request.get(
      `/tunnel_oven/getDayWiseBatchStatusCount/?start_datetime=${start_datetime}&end_datetime=${end_datetime}`
    );
  };
  export const getClassWiseDispatchStatsCount = (start_datetime, end_datetime) => {
    return request.get(
      `/tunnel_oven/getClassWiseDispatchStatsCount/?start_datetime=${start_datetime}&end_datetime=${end_datetime}`
    );
  };
  export const getClasswiseAverageProcessingTime = (start_datetime, end_datetime) => {
    return request.get(
      `/tunnel_oven/getClasswiseAverageProcessingTime/?start_datetime=${start_datetime}&end_datetime=${end_datetime}`
    );
  };

  export const getProngOvenDuration = (scanned_po_name) => { // Accept scanned_po_name as a parameter
    return request.get(
      `/tunnel_oven/getProngOvenDuration/?scanned_po_name=${scanned_po_name}`
    );
  };
  export const getDippingTankList = () => { // Accept scanned_po_name as a parameter
    return request.get(
      `/tunnel_oven/getDippingTankList/`
    );
  };
  export const getLeachingConductivity = () => { // Accept scanned_po_name as a parameter
    return request.get(
      `/tunnel_oven/getLeachingConductivity/`
    );
  };
  export const getDippingTankCellValues = (selectedDippingOption) => { // Accept scanned_po_name as a parameter
    return request.get(
      `/tunnel_oven/getDippingTankCellValues/?tank_no=${selectedDippingOption}`
    );
  };
  export const getSFGStoreStatusCount = (start_datetime, end_datetime, sfg_type) => {
    return request.get(
      `/tunnel_oven/getSFGStoreStatusCount/?start_datetime=${start_datetime}&end_datetime=${end_datetime}&filter_type=${sfg_type}` // Add sfg_type to the query
    );
  };
  export const getAlarmTolaranceDetail = () => { // Accept scanned_po_name as a parameter
    return request.get(`/tunnel_oven/getAlarmTolaranceDetail/`);
  };
  export const getSystemInsights = () => { // Accept scanned_po_name as a parameter
    return request.get(`/tunnel_oven/getSystemInsights/`);
  };

  export const getProductClassWiseCount = (data) => { // Accept scanned_po_name as a parameter
    return request.post(`/tunnel_oven/getProductClassWiseCount/`,data);
  };